export class ExchangeRate {
    constructor(
        public id: number,
        public name: string,
        public fullName: string,
        public defaultValue: string,
    ) { }
}